module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/blue-b7f4a83dd8fa16077bc1d35c0731b335.png";